import React from "react";
import { UnconfirmedStage } from "./UnconfirmedStage";
import { LoadingStage } from "./LoadingStage";
import { DoneStage } from "./DoneStage";

export type ConfirmStage = "unconfirmed" | "loading" | "done";

export type ConfirmSwiperProps = React.PropsWithChildren & {
  stage: ConfirmStage;
  onAccept?: () => void;
};

export const ConfirmSwiper: React.FC<ConfirmSwiperProps> = ({
  stage,
  onAccept = () => {
    return;
  },
}) => {
  switch (stage) {
    case "unconfirmed":
      return <UnconfirmedStage onAccept={onAccept} />;
    case "loading":
      return <LoadingStage />;
    case "done":
      return <DoneStage />;
  }
};
